module.exports = "../fontawesome-webfont.eot";